import service from '@/store/services/articles/article-types-service';

const state = {
    list: [],
    type: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, type) => {
        state.type = type;
    },
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((type) => { commit('SET_RESOURCE', type); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((type) => { commit('SET_RESOURCE', type); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((type) => { commit('SET_RESOURCE', type); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    all: state => state.list.map(t => ({
        id: t.id,
        value: t.name,
        slug: t.slug
    })),
    getTypeByName: state => (name) => {
        return state.list.find(t => t.name === name)
    },
    hasCategories: (state, getters) => (name) => {
        let currType = getters.getTypeByName(name)
        if(currType && currType?.categories) {
            return currType.categories.length > 0
        }
        return false
    },
    hasSections: (state, getters) => (name) => {
        let currType = getters.getTypeByName(name)
        if(currType && currType?.sections) return currType.sections.length > 0
        return false
    },
    type: state => state.type,
};

const article_types = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default article_types;